import * as React from "react";

const ManagerUser = (props) => (
    <svg
        width={68}
        height={77}
        viewBox="0 0 68 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={34} cy={34} r={33} fill="white" />
        <circle cx={34} cy={34} r={30} fill="#DBE5EE" />
        <path
            d="M55.5 55L51 60L46.5 62.5C49.5 54.5 39.4 50.4 39 50C38.6 49.6 37.5 46 37.5 43C36.5 43.1667 33.3394 38.5762 35.5 38C43 36 40.8333 30.5 40.5 25.5C40.1667 25.5 38.6 25.3 35 24.5C31.4 23.7 30.1667 19.8333 29.5 18C29.5 18 32 17.5 34.5 16.5C37 15.5 34.5 10 34.5 10L39 12.5L38.5 17L42.5 19.5L44 24L44.5 25.5V35.5L43 39L41 41.5V45L42.5 47.5L47 48L52 49.5L55.5 55Z"
            fill="white"
        />
        <path
            d="M41 41.5001C41.0001 43.5793 40.4496 47.7664 44.109 48.0991C48.6833 48.5149 53.2574 48.0991 54.505 55.1684"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M29.1386 41.4456C29.1386 43.5248 29.4713 47.7663 25.8119 48.099C21.2376 48.5149 16.2475 48.099 15 56"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M44.7724 29.802C44.7724 33.6325 44.1544 36.9355 42.6469 39.2544C41.1887 41.4973 38.8204 42.9406 34.9605 42.9406C31.3236 42.9406 28.9412 41.5082 27.4223 39.2426C25.8625 36.916 25.1486 33.6084 25.1486 29.802C25.1486 25.9702 25.7672 22.7597 27.2657 20.5307C28.7139 18.3763 31.0788 17 34.9605 17C37.9404 17 40.0004 17.8559 41.4408 19.2718C42.9036 20.7096 43.8397 22.8346 44.3361 25.5743C44.6471 27.2907 44.7724 28.0611 44.7724 29.802Z"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M31 36C31 36 31.8889 38 35 38C38.1111 38 39 36 39 36"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M27.4753 47.2673L35 51.4998L42.4456 47.2673"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M44.1089 35.6238C44.1089 35.6238 47.4356 35.6242 47.4357 31.7075C47.4357 27.7908 45.1069 28.1471 45.1069 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M25.8119 35.6238C25.8119 35.6238 22.4852 35.6242 22.4852 31.7075C22.4852 27.7908 24.8139 28.1471 24.8139 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M30.9208 17.4061C30.9208 17.4061 28.9999 10.4999 34.9999 10.4999C41 10.4999 38.9999 17.4061 38.9999 17.4061"
            stroke="#333F50"
            strokeWidth={2}
        />
        <circle cx={34} cy={34} r={33} stroke="#333F50" strokeWidth={2} />
        <circle
            cx={35}
            cy={64}
            r={12}
            fill="#DBE4EE"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M46 64C46 70.0751 41.0751 75 35 75C35 75 41.2857 70.0751 41.2857 64C41.2857 57.9249 35 53 35 53C41.0751 53 46 57.9249 46 64Z"
            fill="white"
        />
        <path
            d="M35.2248 56.6347C35.3292 56.3939 35.6708 56.3939 35.7752 56.6347L37.7378 61.1605C37.7812 61.2607 37.8758 61.3294 37.9845 61.3398L42.8953 61.8077C43.1566 61.8326 43.2622 62.1575 43.0654 62.3313L39.3676 65.5963C39.2857 65.6686 39.2495 65.7797 39.2733 65.8864L40.3458 70.7014C40.4028 70.9576 40.1265 71.1584 39.9004 71.0249L35.6525 68.517C35.5584 68.4615 35.4416 68.4615 35.3475 68.517L31.0996 71.0249C30.8735 71.1584 30.5972 70.9576 30.6542 70.7014L31.7267 65.8864C31.7505 65.7797 31.7143 65.6686 31.6324 65.5963L27.9346 62.3313C27.7378 62.1575 27.8434 61.8326 28.1047 61.8077L33.0155 61.3398C33.1242 61.3294 33.2188 61.2607 33.2622 61.1605L35.2248 56.6347Z"
            fill="#333F50"
        />
    </svg>
);

export default ManagerUser;
